import { render, staticRenderFns } from "./ProfileAudit.vue?vue&type=template&id=f13d1476&"
import script from "./ProfileAudit.vue?vue&type=script&lang=js&"
export * from "./ProfileAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports